import { render, staticRenderFns } from "./CorporateRbac.vue?vue&type=template&id=60efd8cf"
import script from "./CorporateRbac.vue?vue&type=script&lang=js"
export * from "./CorporateRbac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports